import { enumType } from '@shared/core/types/common';

enum DELIVERY_STATUS {
    PENDING = OLO.Enums.DELIVERY_STATUS.PENDING,
    WAITING_FOR_PICKUP = OLO.Enums.DELIVERY_STATUS.WAITING_FOR_PICKUP,
    IN_PROGRESS = OLO.Enums.DELIVERY_STATUS.IN_PROGRESS,
    ABOUT_TO_COMPLETE = OLO.Enums.DELIVERY_STATUS.ABOUT_TO_COMPLETE,
    COMPLETED = OLO.Enums.DELIVERY_STATUS.COMPLETED,
    CANCELED = OLO.Enums.DELIVERY_STATUS.CANCELED,
    RETURNED = OLO.Enums.DELIVERY_STATUS.RETURNED,
}

export const deliveryStatusEnum = enumType('DELIVERY_STATUS', DELIVERY_STATUS);
